import React from 'react'
import { CONNECTED_SYSTEMS } from './mockData'

export default function ConnectedSystems() {
  return (
    <div>
      <div className="section-head">
        <h3>Connected Systems</h3>
        <span className="pill pill-ok" style={{ fontSize: '9.5px', marginLeft: 6 }}><span className="dot" />Synced</span>
      </div>
      <div className="integration-row">
        {CONNECTED_SYSTEMS.map((sys) => (
          <div className="integration-card" key={sys.id}>
            <div
              className="int-logo"
              style={{ background: sys.logoBg, color: sys.logoColor, fontFamily: 'var(--f-display)' }}
            >
              {sys.logoLetter}
            </div>
            <div className="int-body">
              <div className="int-name">{sys.name}</div>
              <div className="int-desc">{sys.desc}</div>
              <div className="int-stats">
                {sys.stats.map((s, i) => (
                  <span className="int-stat" key={i}>
                    {s.label === 'Synced' ? <>{s.label} <b>{s.value}</b></> : <><b>{s.value}</b> {s.label}</>}
                  </span>
                ))}
              </div>
            </div>
            <button className="dbtn dbtn-outline" style={{ flexShrink: 0 }}>{sys.buttonLabel}</button>
          </div>
        ))}
      </div>
    </div>
  )
}
